import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomMessage from 'components/common/CustomMessage';
import PageHeader from 'components/common/PageHeader';
import { useEffect, useState } from 'react';
import { Button, Card, Modal, Spinner } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getColabs } from 'redux/colabsSlice';
import {
  getRealEstateByUserId,
  getRealEstateData
} from 'redux/realEstateSlice';
import { getRolByRealEstate } from 'redux/rolesSlice';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import { checkPermission } from 'utils/checkPermission';
import CreateModal from './modals/CreateModal';
import ListaUsuarios from './tables/UserTable';

const UserListPage = () => {
  const colaboradores = useSelector(state => state.colabs.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modalShow, setModalShow] = useState(false);
  const [switchNewUser, setSwitchNewUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userLogged = useSelector(state => state.login.currentUser);
  const branchOffices = useSelector(
    state => state.realEstate.branchOfficesArray
  );
  const realEstate = useSelector(state => state.realEstate.realEstate);

  const roles = useSelector(state => state.roles.data);

  useEffect(() => {
    setIsLoading(true);
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    if (realEstate.id) {
      dispatch(getRealEstateData(realEstate.id));
      dispatch(getRolByRealEstate(realEstate.id));
      dispatch(getColabs());
      setIsLoading(false);
    }
  }, [realEstate]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getColabs());
    setIsLoading(false);
  }, [switchNewUser]);

  const [noRolesModal, setNoRolesModal] = useState(false);

  return (
    <>
      <PageHeader
        title="Usuarios del Sistema"
        description="Gestioná los usuarios de tu inmobiliaria y sucursales."
        className="mb-3 bg-white"
      >
        {userLogged && checkPermission('Create users', userLogged) && (
          <ButtonCreate
            className="w-100 w-md-auto"
            text="Nuevo Usuario"
            funcion={() => {
              setModalShow(true);
              if (!roles.length) setNoRolesModal(true);
            }}
            variant="primary"
          />
        )}
      </PageHeader>

      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between">
          <Card.Title className="fw-light d-flex align-items-center gap-2">
            <span className="fs-0">
              <FontAwesomeIcon icon="fa-regular fa-user" />
            </span>

            <span>Listado de Usuarios</span>
          </Card.Title>
        </Card.Header>

        <Card.Body>
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: '600px', paddingBottom: '300px' }}
            >
              <Spinner
                animation="border"
                style={{
                  color: '#2c7be5'
                }}
              />
            </div>
          ) : colaboradores.length ? (
            <ListaUsuarios
              colaboradores={colaboradores}
              switchNewUser={switchNewUser}
              setSwitchNewUser={setSwitchNewUser}
            />
          ) : (
            <CustomMessage
              message="Podés crear usuarios haciendo click en el botón 'Nuevo Usuario'."
              title="No hay usuarios registrados."
              ReactIcon={FaUser}
            />
          )}
        </Card.Body>
      </Card>

      {branchOffices && roles.length > 0 && (
        <CreateModal
          modalShow={modalShow}
          setModalShow={setModalShow}
          roles={roles}
          switchNewUser={switchNewUser}
          setSwitchNewUser={setSwitchNewUser}
          branchOffices={branchOffices}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}

      <Modal show={noRolesModal} onHide={() => setNoRolesModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>No hay roles disponibles.</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="fs-1">
            Debes crear al menos un rol antes de poder crear usuarios.
          </p>

          <div className="d-flex justify-content-between">
            <Button variant="secondary" onClick={() => setNoRolesModal(false)}>
              Cerrar
            </Button>

            <Button
              variant="primary"
              onClick={() => navigate('/permisos/roles')}
            >
              Crear rol
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserListPage;
